import defaultTranslation from '@rc-d2c/config-utils/translations/defaultTranslation.json';
import { InitOptions } from 'i18next';

import { COUNTRY_FALLBACK_LOCALES, SUPPORTED_LOCALES } from './locales.constants';

export const fallbackLng = 'en';
export const languages = [...SUPPORTED_LOCALES, ...Object.keys(COUNTRY_FALLBACK_LOCALES)];
export const defaultNS = 'translation';
export const cookieName = 'i18next';

export const generateI18nInitOptions: () => InitOptions = () => ({
  fallbackLng,
  supportedLngs: languages,
  defaultNS,
  debug: false,
  returnObjects: true,
  resources: {
    en: {
      translation: defaultTranslation,
    },
  },
});
